import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'componentsCallouts',
    label: 'Components Callouts',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
